<template>
  <div class = "previewer">
    <div class = "curtain" ref = "curtain"></div>
    <div v-if = "sketchRunning || autoplay">
      <iframe :src = "getUrl()" ref = "iframe" v-on:load = "onLoadIframe"></iframe>
    </div>

    <!--
    sketch se esta reproduciendo
    1) Clicko en stop => muestro overlay oscuro
    2) Clicko en play => cargo nuevo sketch
    3) Quito overlay oscuro
    -->

    <div v-if = "editorConfig.isShowingMediaFacadeCutout" id = "media-facade-overlay" :class = "{ border: border }">
      <div id = "left_up_one" :style = "{background: bgColor}"></div>
      <div id = "left_up_two" :style = "{background: bgColor}"></div>
      <div id = "left_down" :style = "{background: bgColor}"></div>

      <div id = "right_up_one" :style = "{background: bgColor}"></div>
      <div id = "right_up_two" :style = "{background: bgColor}"></div>

      <div id = "right_down" :style = "{background: bgColor}"></div>

      <div id = "main"></div>
      <div id = "top" :style = "{background: bgColor}"></div>
      <div id="broken-leds" v-if="showBrokenLeds">
        <img src="/static/img/overlaypantalla.png">
      </div>
    </div>

    <div v-show = "editorConfig.isShowingInfoOverlay && showOverlay" id = "project-extra" >
      <div ref = "banner" id = "project-info" class = "baseShow">
        <p class = "name">{{project.name}}</p>
        <div v-if = "project.owner">
          <p class = "author">{{project.owner.name}}</p>
          <p class = "link">{{project.owner.social_link}}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Previewer',
  props: {
    bgColor: {
      type: String,
      default: 'rgba(255, 255, 255, 1)'
    },
    project: Object,
    autoplay: {
      type: Boolean,
      default: false
    },
    showOverlay: {
      type: Boolean,
      default: true
    },
    autoHideOverlay: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true
    },
    showBrokenLeds: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'editorConfig.isSketchRunning': function (isRunning) {
      // console.log('isRunning', isRunning)

      // https://css-tricks.com/restart-css-animation/
      // esto es una niapa para reiniciar la animacion por css, pero si uso v-ifs y cosas asi por algun motivo extranio se recarga el canvas y se ve como un parpadeo en la animacion!!!
      let banner = this.$refs.banner
      let curtain = this.$refs.curtain

      if (isRunning) {
        this.sketchRunning = true
        curtain.classList.add('show')

        setTimeout(() => {
          banner.classList.add('show')
        }, 1000)

        setTimeout(() => {
          banner.classList.remove('show')
        }, 5000)
      } else {
        curtain.classList.add('show')
        this.sketchRunning = false
        banner.classList.remove('show')
      }
    }
  },
  data () {
    return {
      sketchRunning: false,
      num: 0,
      timeToHide: 5000
    }
  },
  computed: {
    editorConfig () {
      return this.$store.state.editorConfig
    }
  },
  methods: {
    getUrl: function () {
      // this prevents caching nice for development
      return 'indexviz.html?' + Math.random().toString(36).substr(2, 5)
    },
    screenshot: function () {
    },
    close: function () {
    },
    setProjectData: function () {
      // console.log('cuak')
      this.iframe.contentWindow.appviz.setProjectData(this.project)
    },
    sendProjectRTData: function (data) {
      if (this.iframe && this.iframe.contentWindow && this.iframe.contentWindow.appviz && this.iframe.contentWindow.appviz.sendProjectRTData) {
        this.iframe.contentWindow.appviz.sendProjectRTData(data)
      }
    },
    getStorageForProject: function (project) {
      return this.iframe.contentWindow.appviz.getStorageForProject(project)
    },
    clearStorageForProject: function (project) {
      this.iframe.contentWindow.appviz.clearStorageForProject(project)
    },
    onLoadIframe: function () {
      this.iframe = this.$refs.iframe
      // console.log(this.iframe.contentWindow)

      // register callback; this is coming from the iframe
      this.iframe.contentWindow.appviz.setActionCallback((action, data) => {
        // console.log('(Previewer) actionCallback', action, data)

        switch (action) {
          case 'ready':
            this.sketchRunning = true
            this.setProjectData()
            // console.log('setprojectdata')
            let curtain = this.$refs.curtain
            curtain.classList.remove('show')

            break
          case 'log':
            this.$store.commit('addConsoleLine', data)
            break
          case 'tracking':
            // console.log('change to tracking')
            this.$store.commit('setEditorConfigProperty', {'selectedModule': 'api-tracking'})
            this.$store.commit('setEditorConfigProperty', {'videoPlayerShouldStartPlaying': true})
            break
          default:
            // console.log('(Previewer) no action defined')
        }
      })
    }
  },
  created () {
  },
  mounted () {
    // register event (from, data)
    this.$eventHub.$on('rtdata', (ev) => {
      // console.log('rtdata event', ev)
      switch (ev.from) {
        case 'onStorageRequest':
          let data = this.getStorageForProject(this.project)
          // console.log('qq', data)
          this.$store.commit('setStoragePreview', data)
          break
        case 'onStorageClear':
          this.clearStorageForProject(this.project)
          break
        default:
          this.sendProjectRTData(ev)
      }
    })
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.previewer {
  width: 192px;
  padding: 0px;
  height: 157px;
  display: flex;
  position: relative;
  background: black;

  .curtain {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f1f1f1;
    background: black;
    transition: all ease-in-out 0.3s;
    opacity: 0;

    &.show {
      opacity: 1;
    }
  }
}

iframe {
  width: 192px;
  height: 157px;
  // box-shadow: 0px 0px 2px 2px #0002;
  border: 0;
  // outline: 2px solid white;
}

.toolbar {
  display: flex;
  position: absolute;
  top: 0px;
  width: 100%;

  p { flex: 1; }
}

@borderWidth: 2px;
@borderColor: #2e2e2e;

#media-facade-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  pointer-events: none;
  // overflow: hidden;

  * {
    background: white;
    position: absolute;
    image-rendering: auto;
    image-rendering: crisp-edges;
    image-rendering: pixelated;
  }

  &.border {
    #left_up_two {
      box-shadow: @borderWidth @borderWidth 0 @borderColor;
    }

    #left_down {
      box-shadow: @borderWidth @borderWidth 0 @borderColor;
    }

    #right_up_two {
      box-shadow: -@borderWidth @borderWidth 0 @borderColor;
    }

    #right_down {
      box-shadow: -@borderWidth @borderWidth 0 @borderColor;
    }

    #main {
      box-shadow: 0px 3px 0px @borderWidth @borderColor;
      bottom: @borderWidth;
      width: 192px - 2 * @borderWidth; // 192
      height: 124px;
      background: #03ffaf00;
      left: @borderWidth;
    }

    #top {
      top: -1px;
      left: 71px;
      width: 50px;
      background: transparent;
      box-shadow: 0 @borderWidth 0px 1px @borderColor;
    }
  }

  #left_up_one {
    top: 0px;
    left: 0px;
    width: 36px;
    height: 15px;
  }

  #left_up_two {
    top: 0px;
    left: calc(35px - @borderWidth);
    width: calc(35px + @borderWidth);
    height: 15px;
  }

  #left_down {
    top: 14px;
    left: 0px;
    width: 35px;
    height: 17px;
  }

  #right_up_one {
    top: 0px;
    right: -1px;
    width: 37px;
    height: 15px;
  }

  #right_up_two {
    top: 0px;
    right: calc(35px - @borderWidth);
    width: calc(35px + @borderWidth);
    height: 15px;
  }

  #right_down {
    top: 14px;
    right: -1px;
    width: 36px;
    height: 17px;
  }
  #broken-leds{
    background:transparent;
    top:0;
    left:0;
    width:192px;
    height:157px;
    img{
      background: transparent;
    }
  }
}

#project-extra {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  // background: #ff06;

  #project-info {
    position: absolute;
    transform: translate3d(0px, 70px, 0);
    transition: all ease-in-out 300ms;
    bottom: 0;
    width: 100%;
    background: #000b;
    border-top: 2px solid #fffb;
    color: #ccc;
    font-size: 7px;
    padding: 8px;

    .name {
      color: @accentColor;
      font-size: 10px;
      font-weight: 800;
    }
  }

  p {
    padding: 0px;
  }
}

.baseShow {
  display: block !important;
}

.show {
  transform: translate3d(0px, 0px, 0) !important;
}

/*
  animation-name: animationShow;
  animation-duration: 500ms;
  animation-delay: 4s;
  animation-timing-function: ease-out;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
*/

.previewer-fullscreen {
  #left_up_one, #left_up_two, #left_down, #right_up_one, #right_up_two, #right_down {
    background: rgb(16, 16, 16) !important;
  }
}

// se usa bottom ya que translate o translate3d difumina el texto
@keyframes animationShow {
  from {
    opacity: 1;
    bottom: 0px;
  }

  to {
    opacity: 0;
    bottom: -50px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Previewer/Previewer.vue